export type FontSizeType = "XS" | "SM" | "BASE" | "LG" | "XL" | "2XL" | "3XL" | "4XL" | "5XL" | "6XL" | "7XL" | "8XL";

type FontSizes = {
  [key in FontSizeType]: `${string}rem`;
};

export const convertFontSizeType = (
  size?:
    | "SMALLER"
    | "SMALL"
    | "BASE"
    | "LARGE"
    | "X-LARGE"
    | "2X-LARGE"
    | "3X-LARGE"
    | "4X-LARGE"
    | "5X-LARGE"
    | "6X-LARGE"
    | "7X-LARGE"
    | "8X-LARGE"
) => {
  switch (size) {
    case "SMALLER":
      return "XS";
    case "SMALL":
      return "SM";
    case "BASE":
      return "BASE";
    case "LARGE":
      return "LG";
    case "X-LARGE":
      return "XL";
    case "2X-LARGE":
      return "2XL";
    case "3X-LARGE":
      return "3XL";
    case "4X-LARGE":
      return "4XL";
    case "5X-LARGE":
      return "5XL";
    case "6X-LARGE":
      return "6XL";
    case "7X-LARGE":
      return "7XL";
    case "8X-LARGE":
      return "7XL";
    default:
      return "BASE";
  }
};

export const fontSizes: FontSizes = {
  XS: "0.69rem",
  SM: "0.75rem",
  BASE: "0.82rem",
  LG: "0.91rem",
  XL: "1rem",
  "2XL": "1.125rem",
  "3XL": "1.25rem",
  "4XL": "1.5rem",
  "5XL": "1.875rem",
  "6XL": "2.25rem",
  "7XL": "2.7rem",
  "8XL": "3.125rem",
};
